<template>
  <div>

    <navbar></navbar>

    <div class="bg-header-round-small">
      <div class="container">
        <h1>Passwort zurücksetzen</h1>
      </div>
    </div>

    <div class="container" >
      <div class="w-full">
        <h2 class="w-full">Meine Email-Adresse</h2>
        <div class="form-field sized">
          <label for="inputEmail">Email</label>
          <input
              v-model="email"
              name="email"
              v-validate="'email'"
              :class="{'error': errors.has('email') }"
              type="email"
              placeholder="Email..."
              id="inputEmail"
          >
          <span v-show="errors.has('email')" class="errorMsg">{{ errors.first('email') }}</span>
        </div>
      </div>
      <div class="w-full">
        <h2 class="w-full">Mein Passwort</h2>
        <div class="form-field sized">
          <label for="inputPassword">Neues Passwort</label>
          <input
              v-model="password"
              name="password"
              v-validate="'required|min:6|max:50'"
              :class="{'error': errors.has('password') }"
              type="password"
              placeholder="Passwort..."
              id="inputPassword"
              >
          <span v-show="errors.has('password')" class="errorMsg">{{ errors.first('password') }}</span>
        </div>
        <div class="form-field sized">
          <label for="inputPasswordConfirmation">Passwort bestätigen</label>
          <input
              v-model="passwordConfirmation"
              name="passwordConfirmation"
              v-validate="'required|confirmed:password'"
              :class="{'error': errors.has('passwordConfirmation') }"
              type="password"
              placeholder="Passwort bestätigen..."
              id="inputPasswordConfirmation"
              @keyup.enter.prevent="resetPw">
          <span v-show="errors.has('passwordConfirmation')"
                class="errorMsg">{{ errors.first('passwordConfirmation') }}</span>
        </div>
        <button class="btn orange" @click.prevent="resetPw">Passwort speichern</button>
      </div>
    </div>
    <cgfooter></cgfooter>

  </div>
</template>

<script>
  import Navbar from '../components/Navbar.vue'
  import CgFooter from '../components/CgFooter.vue'

  import { mapGetters, mapActions } from 'vuex'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'PasswordReset',
    components: {
      'navbar': Navbar,
      'cgfooter': CgFooter
    },
    mixins: [helpers, formatting],
    data () {
      return {
        user: '',
        token: '',
        password: '',
        passwordConfirmation: '',
        email: '',
        saveToast: null
      }
    },
    created () {
      this.token = this.$route.params.token
    },
    methods: {
      ...mapActions([
        'resetPassword'
      ]),
      resetPw () {
        var vm = this
        let data = {}
        data.params = {
          email: vm.email,
          password: vm.password,
          password_confirmation: vm.passwordConfirmation
        }
        data.token = vm.token
        data.cb = () => {
          vm.$toasted.success('Dein Passwort wurde aktualisiert.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'check'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
          vm.goTo('home')
        }
        data.errorCb = () => {
          vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        if (!vm.saveToast) {
          vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            icon: 'info'
          })
          vm.resetPassword(data)
        }
      }
    },
    computed: {
      ...mapGetters({
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/PasswordReset.vue